// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"pin-note-sidebar-entry_highlighted__cABS8"};